import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7cc13b6a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-lg container-fluid shadow-sm py-3" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12 mb-3" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "overflow text-primary h5" }, "Business/Organisation Details")
], -1))
const _hoisted_4 = { class: "p-float-label prime_input" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "orgType",
  class: "overflow"
}, [
  /*#__PURE__*/_createTextVNode(" Type of business/organization"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_6 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "other" }, [
  /*#__PURE__*/_createTextVNode("If Other, then describe"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger mx-1" }, "*")
], -1))
const _hoisted_8 = { class: "col-12" }
const _hoisted_9 = { class: "p-float-label prime_input" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "name" }, [
  /*#__PURE__*/_createTextVNode("Legal /registered name"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_11 = { class: "col-12" }
const _hoisted_12 = { class: "p-float-label prime_input" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "name" }, [
  /*#__PURE__*/_createTextVNode("Source of funding for your Business/Organization "),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_14 = { class: "col-12" }
const _hoisted_15 = { class: "p-float-label prime_input" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "countryOfReg",
  class: "overflow"
}, [
  /*#__PURE__*/_createTextVNode("Country of residence "),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_17 = { class: "col-12" }
const _hoisted_18 = { class: "col-12 mb-3" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "descriptionOrg" }, [
  /*#__PURE__*/_createTextVNode("Short description about the organization, qualification(s), and experience"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger mx-1" }, "*")
], -1))
const _hoisted_20 = { class: "col-12" }
const _hoisted_21 = { class: "p-float-label prime_input" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "businessSector",
  class: "overflow"
}, [
  /*#__PURE__*/_createTextVNode("Business Sector"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_23 = {
  key: 1,
  class: "col-md-12"
}
const _hoisted_24 = { class: "p-float-label prime_input" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "businessSector" }, [
  /*#__PURE__*/_createTextVNode("if Others, please specify... "),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_26 = { class: "col-md-6" }
const _hoisted_27 = { class: "p-float-label prime_input" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "orgEmail" }, [
  /*#__PURE__*/_createTextVNode("Email "),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_29 = { class: "col-md-6" }
const _hoisted_30 = { class: "p-float-label prime_input" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "mobile" }, [
  /*#__PURE__*/_createTextVNode("Mobile "),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_32 = { class: "col-12" }
const _hoisted_33 = { class: "p-float-label prime_input mb-0" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "web" }, "Website", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "text-muted" }, [
  /*#__PURE__*/_createElementVNode("em", null, "https://www.website.com")
], -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "text-primary my-3" }, " Business/Organisation Contact Person Details. ", -1))
const _hoisted_37 = { class: "row" }
const _hoisted_38 = { class: "col-md-4" }
const _hoisted_39 = { class: "p-float-label prime_input" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "altFirstname" }, [
  /*#__PURE__*/_createTextVNode("First Name "),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_41 = { class: "col-md-4" }
const _hoisted_42 = { class: "p-float-label prime_input" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "altMiddlename" }, "Middle Name", -1))
const _hoisted_44 = { class: "col-md-4" }
const _hoisted_45 = { class: "p-float-label prime_input" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "altLastname" }, [
  /*#__PURE__*/_createTextVNode("Last Name "),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_47 = { class: "col-12" }
const _hoisted_48 = { class: "p-float-label prime_input" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "lastname" }, [
  /*#__PURE__*/_createTextVNode("ID/Passport Number "),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_50 = { class: "col-md-6" }
const _hoisted_51 = { class: "p-float-label prime_input" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "nationality",
  class: "overflow"
}, [
  /*#__PURE__*/_createTextVNode("Country of Origin "),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_53 = { class: "col-md-6" }
const _hoisted_54 = { class: "p-float-label prime_input" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "countryOfResidence",
  class: "overflow"
}, [
  /*#__PURE__*/_createTextVNode("Country of residence "),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_56 = { class: "col-md-6" }
const _hoisted_57 = { class: "p-float-label prime_input" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "phoneNumber" }, [
  /*#__PURE__*/_createTextVNode("Phone Number "),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_59 = { class: "col-md-6" }
const _hoisted_60 = { class: "p-float-label prime_input" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "gender",
  class: "overflow"
}, [
  /*#__PURE__*/_createTextVNode("Gender "),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_62 = { class: "col-6" }
const _hoisted_63 = { class: "p-float-label prime_input" }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "altUsername" }, [
  /*#__PURE__*/_createTextVNode("User Name "),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_65 = { class: "col-md-6" }
const _hoisted_66 = { class: "p-float-label prime_input" }
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "email" }, [
  /*#__PURE__*/_createTextVNode("Email "),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_68 = { class: "col-md-6 mb-3" }
const _hoisted_69 = { class: "p-float-label prime_input mb-0" }
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "password" }, [
  /*#__PURE__*/_createTextVNode("Password "),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "text-muted" }, [
  /*#__PURE__*/_createElementVNode("em", null, "at least 8 characters")
], -1))
const _hoisted_72 = { class: "col-md-6 mb-3" }
const _hoisted_73 = { class: "p-float-label prime_input mb-0" }
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "confirm_password" }, [
  /*#__PURE__*/_createTextVNode("Confirm Password "),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "text-muted" }, [
  /*#__PURE__*/_createElementVNode("em", null, "at least 8 characters")
], -1))
const _hoisted_76 = { class: "mb-3" }
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "description" }, [
  /*#__PURE__*/_createTextVNode("Short description about yourself, your qualification(s), study and work background(s)"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger mx-1" }, "*")
], -1))
const _hoisted_78 = { class: "terms" }
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "text-primary my-3 text-capitalize" }, " Arms, tobacco disclosure statement ", -1))
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "For the purposes of this statement:", -1))
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Tobacco industry means any entity involved in the manufacture, sale or distribution of tobacco and related products, and any affiliate of such entity; and Arms industry means any entity involved in the manufacture, sale or distribution of arms, and any affiliate of such entity. This disclosure statement needs to be provided by any nongovernmental organization, private sector entity, philanthropic foundation and academic institution prior to engaging with Botswana Ministry of Health. ", -1))
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, " In view of the foregoing, please answer the following questions: ", -1))
const _hoisted_83 = { class: "radio" }
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "radio_text" }, " A. Is your entity, or was your entity over the last four years, part of the tobacco or arms industries (as defined above)? ", -1))
const _hoisted_85 = { class: "option" }
const _hoisted_86 = { class: "field-radiobutton" }
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "is_entity_part_of_tobacco" }, "Yes", -1))
const _hoisted_88 = { class: "field-radiobutton" }
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "is_entity_part_of_tobacco" }, "No", -1))
const _hoisted_90 = { class: "radio" }
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "radio_text" }, " B. To the best of your entity’s knowledge, is your entity, or has your entity over the last four years, engaged in activities that are aimed at furthering or supporting the interests of the tobacco industry? This includes, but is not limited to, supply contracts, contract work, services and lobbying. ", -1))
const _hoisted_92 = { class: "option" }
const _hoisted_93 = { class: "field-radiobutton" }
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "entity_tobacco_engagement" }, "Yes", -1))
const _hoisted_95 = { class: "field-radiobutton" }
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "entity_tobacco_engagement" }, "No", -1))
const _hoisted_97 = { class: "field-radiobutton" }
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "entity_tobacco_engagement" }, "Maybe", -1))
const _hoisted_99 = { class: "radio" }
const _hoisted_100 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "radio_text" }, " C. To the best of your entity’s knowledge, does your entity currently, or did your entity over the last four years, have any other association or relationship with the tobacco industry (as defined above). This includes in particular investment interests (other than general mutual funds or similar arrangements whereby your entity has no control over the selection of the investments), commercial business interests, the provision or receipt of financial and/or other support. ", -1))
const _hoisted_101 = { class: "option" }
const _hoisted_102 = { class: "field-radiobutton" }
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "entity_tobacco_relationship" }, "Yes", -1))
const _hoisted_104 = { class: "field-radiobutton" }
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "entity_tobacco_relationship" }, "No", -1))
const _hoisted_106 = { class: "field-radiobutton" }
const _hoisted_107 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "entity_tobacco_relationship" }, "Maybe", -1))
const _hoisted_108 = { class: "d-flex" }
const _hoisted_109 = { class: "d-flex justify-content-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_AutoComplete = _resolveComponent("AutoComplete")!
  const _component_BaseFileLong = _resolveComponent("BaseFileLong")!
  const _component_RadioButton = _resolveComponent("RadioButton")!
  const _component_BaseCheckBox = _resolveComponent("BaseCheckBox")!
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_TermsAndConditions = _resolveComponent("TermsAndConditions")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", {
      action: "",
      onSubmit: _cache[38] || (_cache[38] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"])),
      ref: "PartnerRegOrg"
    }, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("span", _hoisted_4, [
          _createVNode(_component_Dropdown, {
            id: "orgType",
            name: "orgType",
            modelValue: _ctx.form.orgType,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.orgType) = $event)),
            options: _ctx.orgTypes,
            optionLabel: "id",
            optionValue: "id",
            class: "w-100"
          }, null, 8, ["modelValue", "options"]),
          _hoisted_5
        ]),
        (_ctx.form.orgType === 'Others')
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _hoisted_7,
              _createVNode(_component_Textarea, {
                modelValue: _ctx.form.other,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.other) = $event)),
                id: "other",
                name: "other",
                autoResize: true,
                rows: "5",
                cols: "30",
                placeholder: "Enter text here ...",
                class: "w-100"
              }, null, 8, ["modelValue"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("span", _hoisted_9, [
            _createVNode(_component_InputText, {
              type: "text",
              id: "name",
              name: "name",
              modelValue: _ctx.form.name,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.name) = $event))
            }, null, 8, ["modelValue"]),
            _hoisted_10
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("span", _hoisted_12, [
            _createVNode(_component_InputText, {
              type: "text",
              id: "source_of_funding",
              name: "source_of_funding",
              modelValue: _ctx.form.source_of_funding,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.source_of_funding) = $event))
            }, null, 8, ["modelValue"]),
            _hoisted_13
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("span", _hoisted_15, [
            _createVNode(_component_AutoComplete, {
              modelValue: _ctx.form.countryOfReg,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.countryOfReg) = $event)),
              id: "countryOfReg",
              name: "countryOfReg",
              suggestions: _ctx.selectedCountries,
              onComplete: _cache[5] || (_cache[5] = ($event: any) => (_ctx.searchCountry($event))),
              field: "name",
              class: "w-100"
            }, null, 8, ["modelValue", "suggestions"]),
            _hoisted_16
          ])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createVNode(_component_BaseFileLong, {
            value: _ctx.fileProp,
            docFile: _ctx.docFile,
            "onUpdate:docFile": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.docFile) = $event))
          }, null, 8, ["value", "docFile"])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _hoisted_19,
          _createVNode(_component_Textarea, {
            modelValue: _ctx.form.descriptionOrg,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.descriptionOrg) = $event)),
            id: "descriptionOrg",
            name: "descriptionOrg",
            autoResize: true,
            rows: "5",
            cols: "30",
            placeholder: "Enter text here ...",
            class: "w-100"
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("span", _hoisted_21, [
            _createVNode(_component_Dropdown, {
              id: "businessSector",
              name: "businessSector",
              modelValue: _ctx.form.businessSector,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.businessSector) = $event)),
              options: _ctx.businessType,
              optionLabel: "id",
              optionValue: "id",
              class: "w-100"
            }, null, 8, ["modelValue", "options"]),
            _hoisted_22
          ])
        ]),
        (_ctx.form.businessSector === 'Others')
          ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
              _createElementVNode("span", _hoisted_24, [
                _createVNode(_component_InputText, {
                  type: "text",
                  id: "businessSectorOthers",
                  name: "businessSectorOthers",
                  modelValue: _ctx.form.businessSectorOthers,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.businessSectorOthers) = $event))
                }, null, 8, ["modelValue"]),
                _hoisted_25
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("span", _hoisted_27, [
            _createVNode(_component_InputText, {
              type: "email",
              id: "orgEmail",
              name: "orgEmail",
              modelValue: _ctx.form.orgEmail,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.form.orgEmail) = $event))
            }, null, 8, ["modelValue"]),
            _hoisted_28
          ])
        ]),
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("span", _hoisted_30, [
            _createVNode(_component_InputText, {
              type: "tel",
              id: "mobile",
              name: "mobile",
              modelValue: _ctx.form.mobile,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.form.mobile) = $event))
            }, null, 8, ["modelValue"]),
            _hoisted_31
          ])
        ]),
        _createElementVNode("div", _hoisted_32, [
          _createElementVNode("span", _hoisted_33, [
            _createVNode(_component_InputText, {
              type: "web",
              id: "web",
              name: "web",
              modelValue: _ctx.form.web,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.form.web) = $event))
            }, null, 8, ["modelValue"]),
            _hoisted_34
          ]),
          _hoisted_35
        ])
      ]),
      _hoisted_36,
      _createElementVNode("div", _hoisted_37, [
        _createElementVNode("div", _hoisted_38, [
          _createElementVNode("span", _hoisted_39, [
            _createVNode(_component_InputText, {
              type: "text",
              id: "altFirstname",
              name: "altFirstname",
              modelValue: _ctx.form.altFirstname,
              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.form.altFirstname) = $event))
            }, null, 8, ["modelValue"]),
            _hoisted_40
          ])
        ]),
        _createElementVNode("div", _hoisted_41, [
          _createElementVNode("span", _hoisted_42, [
            _createVNode(_component_InputText, {
              type: "text",
              id: "altMiddlename",
              name: "altMiddlename",
              modelValue: _ctx.form.altMiddlename,
              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.form.altMiddlename) = $event))
            }, null, 8, ["modelValue"]),
            _hoisted_43
          ])
        ]),
        _createElementVNode("div", _hoisted_44, [
          _createElementVNode("span", _hoisted_45, [
            _createVNode(_component_InputText, {
              type: "text",
              id: "altLastname",
              name: "altLastname",
              modelValue: _ctx.form.altLastname,
              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.form.altLastname) = $event)),
              autocomplete: "off"
            }, null, 8, ["modelValue"]),
            _hoisted_46
          ])
        ]),
        _createElementVNode("div", _hoisted_47, [
          _createElementVNode("span", _hoisted_48, [
            _createVNode(_component_InputText, {
              type: "text",
              id: "passportNo",
              name: "passportNo",
              modelValue: _ctx.form.passportNo,
              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.form.passportNo) = $event))
            }, null, 8, ["modelValue"]),
            _hoisted_49
          ])
        ]),
        _createElementVNode("div", _hoisted_50, [
          _createElementVNode("span", _hoisted_51, [
            _createVNode(_component_AutoComplete, {
              modelValue: _ctx.form.nationality,
              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.form.nationality) = $event)),
              id: "nationality",
              name: "nationality",
              suggestions: _ctx.selectedCountries,
              onComplete: _cache[18] || (_cache[18] = ($event: any) => (_ctx.searchCountry($event))),
              field: "name",
              class: "w-100"
            }, null, 8, ["modelValue", "suggestions"]),
            _hoisted_52
          ])
        ]),
        _createElementVNode("div", _hoisted_53, [
          _createElementVNode("span", _hoisted_54, [
            _createVNode(_component_AutoComplete, {
              modelValue: _ctx.form.countryOfResidence,
              "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.form.countryOfResidence) = $event)),
              id: "countryOfResidence",
              name: "countryOfResidence",
              suggestions: _ctx.selectedCountries,
              onComplete: _cache[20] || (_cache[20] = ($event: any) => (_ctx.searchCountry($event))),
              field: "name",
              class: "w-100"
            }, null, 8, ["modelValue", "suggestions"]),
            _hoisted_55
          ])
        ]),
        _createElementVNode("div", _hoisted_56, [
          _createElementVNode("span", _hoisted_57, [
            _createVNode(_component_InputText, {
              type: "text",
              id: "phoneNumber",
              name: "phoneNumber",
              modelValue: _ctx.form.phoneNumber,
              "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.form.phoneNumber) = $event))
            }, null, 8, ["modelValue"]),
            _hoisted_58
          ])
        ]),
        _createElementVNode("div", _hoisted_59, [
          _createElementVNode("span", _hoisted_60, [
            _createVNode(_component_Dropdown, {
              id: "gender",
              name: "gender",
              modelValue: _ctx.form.gender,
              "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.form.gender) = $event)),
              options: _ctx.genders,
              optionLabel: "name",
              class: "w-100"
            }, null, 8, ["modelValue", "options"]),
            _hoisted_61
          ])
        ]),
        _createElementVNode("div", _hoisted_62, [
          _createElementVNode("span", _hoisted_63, [
            _createVNode(_component_InputText, {
              type: "text",
              id: "altUsername",
              name: "altUsername",
              modelValue: _ctx.form.altUsername,
              "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.form.altUsername) = $event)),
              autocomplete: "off"
            }, null, 8, ["modelValue"]),
            _hoisted_64
          ])
        ]),
        _createElementVNode("div", _hoisted_65, [
          _createElementVNode("span", _hoisted_66, [
            _createVNode(_component_InputText, {
              type: "email",
              id: "email",
              name: "email",
              modelValue: _ctx.form.email,
              "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.form.email) = $event))
            }, null, 8, ["modelValue"]),
            _hoisted_67
          ])
        ]),
        _createElementVNode("div", _hoisted_68, [
          _createElementVNode("span", _hoisted_69, [
            _createVNode(_component_InputText, {
              type: "password",
              id: "password",
              name: "password",
              modelValue: _ctx.form.password,
              "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.form.password) = $event))
            }, null, 8, ["modelValue"]),
            _hoisted_70
          ]),
          _hoisted_71
        ]),
        _createElementVNode("div", _hoisted_72, [
          _createElementVNode("span", _hoisted_73, [
            _createVNode(_component_InputText, {
              type: "password",
              id: "confirm_password",
              name: "confirm_password",
              modelValue: _ctx.form.confirm_password,
              "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.form.confirm_password) = $event))
            }, null, 8, ["modelValue"]),
            _hoisted_74
          ]),
          _hoisted_75
        ])
      ]),
      _createElementVNode("div", _hoisted_76, [
        _hoisted_77,
        _createVNode(_component_Textarea, {
          modelValue: _ctx.form.description,
          "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.form.description) = $event)),
          id: "description",
          name: "description",
          autoResize: true,
          rows: "5",
          cols: "30",
          placeholder: "Enter text here ...",
          class: "w-100"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_78, [
        _hoisted_79,
        _hoisted_80,
        _hoisted_81,
        _hoisted_82,
        _createElementVNode("div", _hoisted_83, [
          _hoisted_84,
          _createElementVNode("section", _hoisted_85, [
            _createElementVNode("div", _hoisted_86, [
              _createVNode(_component_RadioButton, {
                id: "is_entity_part_of_tobacco",
                name: "is_entity_part_of_tobacco",
                value: "Yes",
                modelValue: _ctx.form.is_entity_part_of_tobacco,
                "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.form.is_entity_part_of_tobacco) = $event))
              }, null, 8, ["modelValue"]),
              _hoisted_87
            ]),
            _createElementVNode("div", _hoisted_88, [
              _createVNode(_component_RadioButton, {
                id: "is_entity_part_of_tobacco",
                name: "is_entity_part_of_tobacco",
                value: "No",
                modelValue: _ctx.form.is_entity_part_of_tobacco,
                "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.form.is_entity_part_of_tobacco) = $event))
              }, null, 8, ["modelValue"]),
              _hoisted_89
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_90, [
          _hoisted_91,
          _createElementVNode("section", _hoisted_92, [
            _createElementVNode("div", _hoisted_93, [
              _createVNode(_component_RadioButton, {
                id: "entity_tobacco_engagement",
                name: "entity_tobacco_engagement",
                value: "Yes",
                modelValue: _ctx.form.entity_tobacco_engagement,
                "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.form.entity_tobacco_engagement) = $event))
              }, null, 8, ["modelValue"]),
              _hoisted_94
            ]),
            _createElementVNode("div", _hoisted_95, [
              _createVNode(_component_RadioButton, {
                id: "entity_tobacco_engagement",
                name: "entity_tobacco_engagement",
                value: "No",
                modelValue: _ctx.form.entity_tobacco_engagement,
                "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.form.entity_tobacco_engagement) = $event))
              }, null, 8, ["modelValue"]),
              _hoisted_96
            ]),
            _createElementVNode("div", _hoisted_97, [
              _createVNode(_component_RadioButton, {
                id: "entity_tobacco_engagement",
                name: "entity_tobacco_engagement",
                value: "Maybe",
                modelValue: _ctx.form.entity_tobacco_engagement,
                "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.form.entity_tobacco_engagement) = $event))
              }, null, 8, ["modelValue"]),
              _hoisted_98
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_99, [
          _hoisted_100,
          _createElementVNode("section", _hoisted_101, [
            _createElementVNode("div", _hoisted_102, [
              _createVNode(_component_RadioButton, {
                id: "entity_tobacco_relationship",
                name: "entity_tobacco_relationship",
                value: "Yes",
                modelValue: _ctx.form.entity_tobacco_relationship,
                "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.form.entity_tobacco_relationship) = $event))
              }, null, 8, ["modelValue"]),
              _hoisted_103
            ]),
            _createElementVNode("div", _hoisted_104, [
              _createVNode(_component_RadioButton, {
                id: "entity_tobacco_relationship",
                name: "entity_tobacco_relationship",
                value: "No",
                modelValue: _ctx.form.entity_tobacco_relationship,
                "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.form.entity_tobacco_relationship) = $event))
              }, null, 8, ["modelValue"]),
              _hoisted_105
            ]),
            _createElementVNode("div", _hoisted_106, [
              _createVNode(_component_RadioButton, {
                id: "entity_tobacco_relationship",
                name: "entity_tobacco_relationship",
                value: "Maybe",
                modelValue: _ctx.form.entity_tobacco_relationship,
                "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.form.entity_tobacco_relationship) = $event))
              }, null, 8, ["modelValue"]),
              _hoisted_107
            ])
          ])
        ])
      ]),
      _createElementVNode("p", _hoisted_108, [
        _createVNode(_component_BaseCheckBox, {
          checkbox: _ctx.form.terms,
          "onUpdate:checkbox": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.form.terms) = $event)),
          inputType: _ctx.termsProp
        }, null, 8, ["checkbox", "inputType"]),
        _createElementVNode("span", {
          class: "text-primary text-decoration-underline",
          onClick: _cache[37] || (_cache[37] = ($event: any) => (_ctx.termsModal = true))
        }, "Terms and Condition")
      ]),
      _createElementVNode("div", _hoisted_109, [
        _createVNode(_component_BaseButton, {
          disabled: _ctx.loading,
          class: _normalizeClass({ submitting: _ctx.loading }),
          customStyle: _ctx.buttonStyle
        }, {
          default: _withCtx(() => [
            _createTextVNode("Register")
          ]),
          _: 1
        }, 8, ["disabled", "class", "customStyle"])
      ])
    ], 544),
    _createVNode(_component_Dialog, {
      visible: _ctx.termsModal,
      "onUpdate:visible": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.termsModal) = $event)),
      style: { width: '50rem' },
      breakpoints: { '600px': '85vw' },
      modal: true,
      header: " ",
      class: "hide_cloe",
      dismissableMask: true
    }, {
      default: _withCtx(() => [
        _createVNode(_component_TermsAndConditions)
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}